(function () {
    "use strict";

    angular
        .module("iMatApp")
        .factory("modelProcessingService", modelProcessingService);

    modelProcessingService.$inject = ["$http", "$log"];

    function modelProcessingService($http, $log) {
        var baseUrl = "/models/";

        var modelProcessingStatuses = {
            unknown: { code: 0, name: "Unknown" },
            analyzing: { code: 1, name: "Analyzing" },
            fixing: { code: 2, name: "Fixing" },
            mediumFixing: { code: 3, name: "MediumFixing" },
            advancedFixing: { code: 4, name: "AdvancedFixing" },
            done: { code: 5, name: "Done" }
        };

        var modelProcessingResults = {
            unknown: { code: 0, name: "Unknown" },
            succeeded: { code: 1, name: "Succeeded" },
            invalid: { code: 2, name: "Invalid" },
            failed: { code: 3, name: "Failed" },
            aborted: { code: 4, name: "Aborted" }
        };

        return {
            runProcessForBadModel: runProcessForBadModel,

            getProcessingStatus: getProcessingStatus,
            getProcessingResult: getProcessingResult,
            abortProcessing: abortProcessing,

            isModelProcessing: isModelProcessing,

            extendStatusInfo: extendStatusInfo,
            extendResultInfo: extendResultInfo,

            getProcessStatusUrl: getProcessStatusUrl
        };

        function runProcessForBadModel(modelId, canceler) {
            var requestUrl = baseUrl + modelId + "/processing/retry";

            var promise = $http.post(requestUrl, null, { canceler: canceler })
                .then(function (response) {
                    return response.data;
                });

            return promise;
        }

        function getProcessStatusUrl(modelId) {
            return baseUrl + modelId + "/processing/status";
        }

        function getProcessingStatus(modelId) {
            var requestUrl = getProcessStatusUrl(modelId);
            return $http.get(requestUrl)
               .then(function (response) {
                   var status = response.data;
                   return extendStatusInfo(status);
               });
        }

        function getProcessingResult(modelId) {
            return $http.get(baseUrl + modelId + "/processing/result")
               .then(function (response) {
                   var result = response.data;
                   return extendResultInfo(result);
               });
        }

        function abortProcessing(modelId) {
            return $http.post(baseUrl + modelId + "/processing/abort")
                .then(function (response) {
                    return response.data;
                });
        }

        function isModelProcessing(modelId) {
            return getProcessingStatus(modelId)
                .then(function (result) {
                    return !result.isDone();
                });
        }

        function extendStatusInfo(status) {

            var apiObject = {
                isUnknown: function () {
                    return this.code === modelProcessingStatuses.unknown.code;
                },
                isAnalysing: function () {
                    return this.code === modelProcessingStatuses.analyzing.code;
                },
                isFixing: function () {
                    return this.code === modelProcessingStatuses.fixing.code;
                },
                isMediumFixing: function () {
                    return this.code === modelProcessingStatuses.mediumFixing.code;
                },
                isAdvancedFixing: function () {
                    return this.code === modelProcessingStatuses.advancedFixing.code;
                },
                
                isDone: function () {
                    return this.code === modelProcessingStatuses.done.code;
                }
            };

            return angular.extend(status, apiObject);
        }

        function extendResultInfo(result) {
            var apiObject = {
                isUnknown: function () {
                    return this.code === modelProcessingResults.unknown.code;
                },
                isSucceeded: function () {
                    return this.code === modelProcessingResults.succeeded.code;
                },
                isInvalid: function () {
                    return this.code === modelProcessingResults.invalid.code;
                },
                isFailed: function () {
                    return this.code === modelProcessingResults.failed.code;
                },
                isAborted: function () {
                    return this.code === modelProcessingResults.aborted.code;
                }
            };

            return angular.extend(result, apiObject);
        }
    }
}());